// removed by extract-text-webpack-plugin
module.exports = {"shadow-0":"shadow--shadow-0--1QgcZudq","shadow0":"shadow--shadow-0--1QgcZudq","shadow-1":"shadow--shadow-1--RQy9HIz1","shadow1":"shadow--shadow-1--RQy9HIz1","shadow-2":"shadow--shadow-2--Ydw5Pc7y","shadow2":"shadow--shadow-2--Ydw5Pc7y","shadow-3":"shadow--shadow-3--3P0Jp8Zk","shadow3":"shadow--shadow-3--3P0Jp8Zk","shadow-4":"shadow--shadow-4--NfNnl2tk","shadow4":"shadow--shadow-4--NfNnl2tk","shadow-5":"shadow--shadow-5--_3uz3iSy","shadow5":"shadow--shadow-5--_3uz3iSy"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/directives/Shadow/shadow.scss
// module id = 495
// module chunks = 0